import { toast } from "react-toastify";

export const DEFAULT_ERROR_MESSAGE = "Oops! Something went wrong. Please try again later.";

export const showError = (error, defaultErrorMessage = DEFAULT_ERROR_MESSAGE) => {
    toast.error((error && error?.message) || defaultErrorMessage);
};

const htmlDecode = (input) => {
    let doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

export const getErrorMessage = (error) => {
    if(typeof error === "string") {
        showError({ message: error });
    } else if(error.errors) {
        Object.keys(error.errors).map(key => (
            showError({ message: `${key} - ${htmlDecode(error.errors[key][0])}` })
        ));
    } else if(error.message) {
        showError({ message: error.message });
    } else {
        showError();
    }
};
